export default class Type extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			types
		} = this.props;

		return (
			<div className='types'>
				{
					types.map(type => {
						const {bgcolor,value} = type;

						return (
							<div className='type'>
								<div style={{backgroundColor:bgcolor}} className='label'></div>
								<div className='value'>{value}</div>
							</div>
						)
					})
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrmAttendance/components/absenceDetail/Type.js